// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1ROqu","errorLogs":"styles_errorLogs__C-Cr9"};